// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./ITConsultancy.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./DataInfrastructure.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Cyber Security.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./Communication-Solutions.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./Security-Solutions.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Fonts */
:root {
  --default-font: "Roboto",  system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --heading-font: "Montserrat",  sans-serif;
  --nav-font: "Poppins",  sans-serif;
}

/* Global Colors - The following color variables are used throughout the website. Updating them here will change the color scheme of the entire website */
:root { 
  --background-color: #ffffff; /* Background color for the entire website, including individual sections */
  --default-color: #222222; /* Default color used for the majority of the text content across the entire website */
  --heading-color: #172a28; /* Color for headings, subheadings and title throughout the website */
  --accent-color: #222222; /* Accent color that represents your brand on the website. It's used for buttons, links, and other elements that need to stand out */
  --surface-color: #ffffff; /* The surface color is used as a background of boxed elements within sections, such as cards, icon boxes, or other elements that require a visual separation from the global background. */
  --contrast-color: #ffffff; /* Contrast color for text, ensuring readability against backgrounds of accent, heading, or default colors. */
}

/* Nav Menu Colors - The following color variables are used specifically for the navigation menu. They are separate from the global colors to allow for more customization options */
:root {
  
  --nav-color: #222222;  /* The default color of the main navmenu links */
  --nav-hover-color: #0E47E0; /* Applied to main navmenu links when they are hovered over or active */
  --nav-mobile-background-color: #E9F0F8; /* Used as the background color for mobile navigation menu */
  --nav-dropdown-background-color: #B0C5F1; /* Used as the background color for dropdown items that appear when hovering over primary navigation items */
  --nav-dropdown-color: #222222; /* Used for navigation links of the dropdown items in the navigation menu. */
  --nav-dropdown-hover-color: #0E47E0; /* Similar to --nav-hover-color, this color is applied to dropdown navigation links when they are hovered over. */
}

/* Color Presets - These classes override global colors when applied to any section or element, providing reuse of the sam color scheme. */

.light-background {
  --background-color: #ffffff;
  --surface-color: #ffffff;
}

.dark-background {
  --background-color: #ffffff;
  --default-color: #252525;
  --heading-color: #ffffff;
  --surface-color: #252525;
  --contrast-color: #ffffff;


}

.accent-background {
  --background-color: #ffffff;
  --default-color: #252525;
  --heading-color: #252525;
  --accent-color: #ffffff;
  --contrast-color: #000000;
}

/* Smooth scroll */
:root {
  scroll-behavior: smooth;
}

/*--------------------------------------------------------------
# General Styling & Shared Classes
--------------------------------------------------------------*/
body {
  color: var(--default-color);
  background-color: var(--background-color);
  font-family: 'Poppins', sans-serif;
}

a {
  color: var(--accent-color);
  text-decoration: none;
  transition: 0.3s;
}

a:hover {
  color: color-mix(in srgb, var(--accent-color), transparent 25%);
  text-decoration: none;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--heading-color);
  font-family: var(--heading-font);
}

/*--------------------------------------------------------------
# Global Header
--------------------------------------------------------------*/
.header {
  --background-color: #ffffff;
  --heading-color: #252525;
  color: var(--default-color);
  transition: all 0.5s;
  z-index: 997;
  background-color: var(--background-color);
  height: 72px;
}


.header .branding {
  min-height: 60px;

}

.header .logo {
  line-height: 1;
}

.header .logo img {
  height: 72px;
  width: auto;

  
}

.header .logo h1 {
  font-size: 30px;
  margin: 0;
  font-weight: 700;
  color: var(--heading-color);
}

.header .logo span {
  font-size: 32px;
  margin-left: 2px;
  color: var(--nav-hover-color);
}

.scrolled .header {
  box-shadow: 0px 0 18px rgba(0, 0, 0, 0.1);
}

/*--------------------------------------------------------------
# Navigation Menu
--------------------------------------------------------------*/
/* Desktop Navigation */
@media (min-width: 1200px) {
  .navmenu {
    padding: 0;
  }

  .navmenu ul {
    margin: 0;
    padding: 0;
    display: flex;
    list-style: none;
    align-items: center;
  }

  .navmenu li {
    position: relative;
  }

  .navmenu > ul > li {
    white-space: nowrap;
    padding: 15px 14px;
    position: relative;
  }

  .navmenu > ul > li:last-child {
    padding-right: 0;
  }

  .navmenu a,
  .navmenu a:focus {
    color: var(--nav-color);
    font-size: 15px;
    padding: 0 2px;
    font-family: var(--nav-font);
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    transition: 0.3s;
    position: relative;
    cursor: pointer;
  }

  .navmenu a i,
  .navmenu a:focus i {
    font-size: 12px;
    line-height: 0;
    margin-left: 5px;
    transition: 0.3s;
  }

  .navmenu > ul > li > a:before {
    content: "";
    position: absolute;
    height: 2px;
    bottom: -6px;
    left: 0;
    background-color: var(--nav-hover-color);
    visibility: hidden;
    width: 0;
    transition: all 0.3s ease-in-out;
  }

  .navmenu a:hover:before,
  .navmenu li:hover > a:before,
  .navmenu .active:before {
    visibility: visible;
    width: 100%;
  }

  .navmenu li:hover > a,
  .navmenu .active,
  .navmenu .active:focus {
    color: var(--nav-hover-color);
  }

  /* Dropdown styles */
  .navmenu .dropdown-content {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    background: #fff;
    min-width: 200px;
    border-radius: 8px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    z-index: 99;
    padding: 10px 0;
  }

  .navmenu .dropdown-content li {
    width: 100%;
  }

  .navmenu .dropdown-content li a {
    padding: 10px 20px;
    font-size: 14px;
    color: #333;
    transition: background 0.3s;
  }

  .navmenu .dropdown-content li a:hover {
    background: #75acfe;
  }

  .navmenu .dropdown:hover .dropdown-content {
    display: block;
  }
  
}



/* Mobile Navigation */
@media (max-width: 1199px) {
  .mobile-nav-toggle {
    color: var(--nav-color);
    font-size: 30px;
    line-height: 1;
    margin-right: 12px;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    background-color: #B0C5F1;
    padding: 10px;
    border-radius: 6px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  .navmenu {
    padding: 0;
    z-index: 9997;
  }

  .navmenu > ul {
    display: none;
    list-style: none;
    position: fixed;
    top: 60px;
    left: 20px;
    right: 20px;
    bottom: 20px;
    background: linear-gradient(135deg, var(--nav-mobile-background-color), #D9E3F1);
    border-radius: 8px;
    padding: 20px;
    overflow-y: auto;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    transition: 0.3s ease-in-out;
    opacity: 0;
    transform: translateY(-10px);
  }

  .mobile-nav-active .navmenu > ul {
    display: block;
    opacity: 1;
    transform: translateY(0);
  }

  .navmenu a,
  .navmenu a:focus {
    color: var(--nav-dropdown-color);
    padding: 12px 20px;
    font-family: var(--nav-font);
    font-size: 18px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: 0.3s;
    border-radius: 5px;
  }

  /* Mobile Dropdown */
  .navmenu .dropdown-content {
    display: none;
    flex-direction: column;
    padding-left: 20px;
    margin-top: 10px;
  }

  .navmenu .dropdown.open .dropdown-content {
    display: flex;
  }

  .navmenu .dropdown-content li a {
    padding: 8px 16px;
    font-size: 16px;
  }

  /* Disable default link behavior if needed */
  .navmenu .dropdown > a::after {
    margin-left: 8px;
    font-size: 12px;
  }
}


/* Fade-in animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}


/*--------------------------------------------------------------
# Global Footer
--------------------------------------------------------------*/

.footer {
  background-color: var(--background-color);
  color: var(--default-color);
  padding: 40px 20px;
  font-size: 14px;
}

.footer-top {
  gap: 40px;
  flex-wrap: wrap;
}

.footer-left {
  flex: 2 1;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

@media (min-width: 992px) {
  .footer-left {
    flex-direction: row;
  }
}

/* About */
.footer-about .logo {
  display: flex;
  align-items: center;
  font-size: 30px;
  font-weight: 700;
  color: var(--heading-color);
  margin-bottom: 10px;
}

.footer-about p {
  margin-top: 8px;
}

.social-links a {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid color-mix(in srgb, var(--default-color), transparent 50%);
  color: color-mix(in srgb, var(--default-color), transparent 50%);
  margin-right: 10px;
  transition: 0.3s;
}

.social-links a:hover {
  color: #0E47E0;
  border-color: #0E47E0;
  transform: scale(1.1);
}

/* Links */
.footer-links h4 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
}

.footer-links ul {
  list-style: none;
  padding: 0;
}

.footer-links ul li {
  margin-bottom: 8px;
}

.footer-links ul a {
  color: color-mix(in srgb, var(--default-color), transparent 30%);
  text-decoration: none;
  transition: all 0.2s ease-in-out;
}

.footer-links ul a:hover {
  color: #0E47E0;
  transform: scale(1.05);
}

/* Contact Text */
.footer-contact-text h4 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.footer-contact-text p {
  margin: 4px 0;
}

/* Map */
.footer-map {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.map-image {
  width: 100%;
  max-width: 600px;
  border: 2px solid #0E47E0;
  border-radius: 1px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

/* Copyright */
.footer .copyright {
  padding-top: 30px;
  padding-bottom: 30px;
  border-top: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);
  font-size: 13px;
  color: var(--default-color);
}

.footer .sitename-footer,
.footer .sitename {
  color: #0E47E0;
  font-weight: 600;
}



/*--------------------------------------------------------------
# Scroll Top Button
--------------------------------------------------------------*/
.scroll-top {
  position: fixed;
  visibility: hidden;
  opacity: 0;
  right: 15px;
  bottom: -15px;
  z-index: 99999;
  background-color: #0E47E0;
  width: 44px;
  height: 44px;
  border-radius: 50px;
  transition: all 0.4s;
}

.scroll-top i {
  font-size: 24px;
  color: var(--contrast-color);
  line-height: 0;
}

.scroll-top:hover {
  background-color: color-mix(in srgb, var(--accent-color), transparent 20%);
  color: var(--contrast-color);
}

.scroll-top.active {
  visibility: visible;
  opacity: 1;
  bottom: 15px;
}

/*--------------------------------------------------------------
# Disable aos animation delay on mobile devices
--------------------------------------------------------------*/
@media screen and (max-width: 768px) {
  [data-aos-delay] {
    transition-delay: 0 !important;
  }
}

/*--------------------------------------------------------------
# Global Page Titles & Breadcrumbs
--------------------------------------------------------------*/
.page-title {
  --background-color: var(--accent-color);
  --default-color: #fff;
  --heading-color: #fff;
  color: var(--default-color);
  background-color: var(--background-color);
  position: relative;
}

.page-title .heading {
  padding: 160px 0 80px 0;
  border-top: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);
}

.page-title .heading h1 {
  font-size: 38px;
  font-weight: 700;
}

.page-title nav {
  background-color: color-mix(in srgb, var(--default-color), transparent 92%);
  padding: 20px 0;
}

.page-title nav ol {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.page-title nav ol a {
  color: color-mix(in srgb, var(--default-color), transparent 50%);
}

.page-title nav ol a:hover {
  color: var(--default-color);
}

.page-title nav ol li+li {
  padding-left: 10px;
}

.page-title nav ol li+li::before {
  content: "/";
  display: inline-block;
  padding-right: 10px;
  color: color-mix(in srgb, var(--default-color), transparent 50%);
}

/*--------------------------------------------------------------
# Global Sections
--------------------------------------------------------------*/
section,
.section {
  color: rgb(0, 0, 0);
  background-color: var(--background-color);
  padding: 60px 0;
  scroll-margin-top: 112px;
  overflow: clip;
  font-weight: 400;
}

@media (max-width: 1199px) {

  section,
  .section {
    scroll-margin-top: 100px;
  }
}

/*--------------------------------------------------------------
# Global Section Titles
--------------------------------------------------------------*/
.section-title {
  text-align: center;
  padding-bottom: 60px;
  position: relative;
}

.section-title h2 {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 20px;
  padding-bottom: 20px;
  position: relative;
}

.section-title h2:after {
  content: "";
  position: absolute;
  display: block;
  width: 50px;
  height: 3px;
  background: var(--accent-color);
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

.section-title p {
  margin-bottom: 0;
}



/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
.hero {
  width: 100%;
  position: relative;
  padding: 140px 0 0 0;
}

.hero .container {
  position: relative;
  z-index: 3;
}

.hero h2 {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 20px;
}

.hero h2 .accent {
  color: #0E47E0;
}

.hero p {
  color: color-mix(in srgb, var(--default-color), transparent 20%);
  font-weight: 500;
  font-size: medium;
  margin-bottom: 30px;
}

.hero .btn-get-started {
  color: var(--contrast-color);
  background: var(--accent-color);
  font-family: var(--heading-font);
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 1px;
  display: inline-block;
  padding: 14px 40px;
  border-radius: 50px;
  transition: 0.3s;
  border: 2px solid color-mix(in srgb, var(--default-color), transparent 10%);
  background-color: #E9F0F8
}

.hero .btn-get-started:hover {
  border-color: #0E47E0 ;
}

.hero .btn-watch-video {
  font-size: 16px;
  transition: 0.5s;
  margin-left: 25px;
  font-weight: 600;
  color: var(--default-color);
}

.hero .btn-watch-video i {
  color: color-mix(in srgb, var(--default-color), transparent 20%);
  font-size: 32px;
  transition: 0.3s;
  line-height: 0;
  margin-right: 8px;
}

.hero .btn-watch-video:hover i {
  color: #0485f6;
}

@media (max-width: 640px) {
  .hero h2 {
    font-size: 36px;
  }

  .hero .btn-get-started,
  .hero .btn-watch-video {
    font-size: 14px;
  }
}

.hero .icon-boxes {
  
  padding-bottom: 60px;
  z-index: 4;
}

@media (min-width: 1200px) {
  .hero .icon-boxes:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: calc(50% + 20px);
    background-color: #ffffff;
    border-top: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);
  }
}

.hero .icon-box {
  padding: 60px 30px;
  position: relative;
  overflow: hidden;
  background-color: #22484b;
  box-shadow: 0 0 29px 0 rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-in-out;
  border-radius: 8px;
  z-index: 1;
  height: 100%;
  width: 100%;
  text-align: center;
}

.hero .icon-box img {
  width: 100%;
  height: auto;
}

.hero .icon-box .title {
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 24px;
  color: rgb(255, 255, 255);
}

.hero .icon-box .title a {
  color: rgb(255, 255, 255);
  transition: 0.3s;
}

.hero .icon-box .icon {
  margin-bottom: 20px;
  padding-top: 10px;
  display: inline-block;
  transition: all 0.3s ease-in-out;
  font-size: 48px;
  line-height: 1;
  color: rgb(255, 255, 255);
}

.hero .icon-box:hover {
  background-color: rgb(57, 60, 60);
}

.hero .icon-box:hover .title a,
.hero .icon-box:hover .icon {
  color: var(--contrast-color);
}

.gif-title {
  max-width: 90%;
  height: auto;
  display: block;
  margin-bottom: 5px;
  
  animation: fadeInDown 1s ease-in-out;
}
@media (max-width: 576px) {
  .gif-title {
    max-width: 90%;
    margin: 0 auto 2px auto;
  }
}

/* leader section*/
.leaders {
  padding: 4rem 0;
  background: #ffffff;
}

.section-title h2 {
  font-size: 2.5rem;
  font-weight: bold;
  color: #0056b3;
}



.leader-item {
  background: linear-gradient(135deg, #e0f0ff 0%, #ffffff 100%);
  border: 2px solid #a5b4c4;
  padding: 30px 20px;
  border-radius: 16px;
  box-shadow: 0px 8px 20px rgba(0, 70, 140, 0.1);
  text-align: center;
  transition: all 0.3s ease;
}

.leader-item:hover {
  background: linear-gradient(135deg, #d0e8ff 0%, #ffffff 100%);
  transform: translateY(-5px);
  box-shadow: 0px 12px 25px rgba(0, 70, 140, 0.2);
}

.leader-item img {
  width: auto;
  height: 300px;
  object-fit: cover;
  border-radius: 50%;
  margin-bottom: 20px;
  border: 2px solid #3f71a7;
}

.leader-item h3 {
  font-size: 1.4rem;
  color: #0056b3;
  margin-bottom: 10px;
  font-weight: bold;
}

.leader-item p {
  font-size: 1rem;
  color: #000000;
  margin: 0;
}



/* Basic animation settings */
.animated-list li {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.6s ease forwards;
  position: relative;
  padding-left: 30px; /* leave space for arrow */
  list-style: none; /* remove default bullet */
}

/* Arrow before each li */
.animated-list li::before {
  content: "➔"; /* You can change arrow style here */
  position: absolute;
  left: 0;
  top: 0;
  color: #0056b3; /* Dark blue arrow */
  font-size: 18px;
}

/* Delay animation for each */
.animated-list li:nth-child(1) { animation-delay: 0s; }
.animated-list li:nth-child(2) { animation-delay: 1s; }
.animated-list li:nth-child(3) { animation-delay: 2s; }
.animated-list li:nth-child(4) { animation-delay: 3s; }
.animated-list li:nth-child(5) { animation-delay: 4s; }
.animated-list li:nth-child(6) { animation-delay: 5s; }
.animated-list li:nth-child(7) { animation-delay: 6s; }
.animated-list li:nth-child(8) { animation-delay: 7s; }

/* Fade in and move up animation */
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}


/*--------------------------------------------------------------
# Clients Section
--------------------------------------------------------------*/
.clients .swiper {
  padding: 10px 0;

}

.clients .swiper-wrapper {
  height: auto;
  display: flex;  /* Enables flexbox */
  justify-items: center;
  align-items: center;
  

}

.clients .swiper-slide img {
  display: flex;  /* Enables flexbox */
  justify-items: center;
  align-items: center;
  transition: 0.3s;
  
}

.clients .swiper-slide img:hover {
  transform: scale(1.1);
}



/*--------------------------------------------------------------
# Services Section
--------------------------------------------------------------*/
.service-item {
  background: linear-gradient(135deg, #f0f8ff 0%, #ffffff 100%);
  border: 2px solid #a5b4c4;
  padding: 30px 25px;
  border-radius: 20px;
  text-align: center;
  transition: all 0.3s ease-in-out;
  height: 100%;
  box-shadow: 0px 8px 20px rgba(0, 70, 140, 0.08);
  position: relative;
}

.service-item:hover {
  background: linear-gradient(135deg, #d6ebff 0%, #ffffff 100%);
  transform: translateY(-8px);
  box-shadow: 0px 12px 30px rgba(0, 70, 140, 0.2);
}

.service-item .icon {
  font-size: 40px;
  color: #007BFF;
  margin-bottom: 20px;
}

.service-item h3 {
  font-size: 1.5rem;
  color: #0056b3;
  margin-bottom: 15px;
  font-weight: bold;
}

.service-item p {
  color: #000000;
  font-size: 1rem;
  margin-bottom: 20px;
}

.service-item .readmore {
  color: #007BFF;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  transition: 0.3s;
  font-size: 0.95rem;
}

.service-item .readmore i {
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.service-item .readmore:hover i {
  transform: translateX(5px);
}


/*--------------------------------------------------------------
# Contact Section
--------------------------------------------------------------*/
.contact .info-container {
  background-color: #6287E2;
  height: 100%;
  padding: 20px;
}

.contact .info-item {
  width: 100%;
  margin-bottom: 20px;
  padding: 20px;
  color: #222222;
  background-color: color-mix(in srgb, var(--contrast-color), transparent 60%);
}

.contact .info-item:last-child {
  margin-bottom: 0;
}

.contact .info-item i {
  font-size: 20px;
  color: 222222;
  background-color: color-mix(in srgb, var(--contrast-color), transparent 60%);
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  transition: all 0.3s ease-in-out;
  margin-right: 15px;
}

.contact .info-item h3 {
  color: #222222;
  font-size: 20px;
  padding: 0;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 5px;
}

.contact .info-item p {
  padding: 0;
  margin-bottom: 0;
  font-size: 14px;
}

.contact .info-item:hover i {
  background: var(--contrast-color);
  color: var(--accent-color);
}

.contact .email-form {
  background-color: var(--surface-color);
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 100%;
  padding: 30px;
  border-style: solid;
  border-width: 1px;
}

.contact .email-form input[type=text],
.contact .email-form input[type=email],
.contact .email-form textarea {
  font-size: 14px;
  padding: 10px 15px;
  box-shadow: none;
  border-radius: 0;
  color: var(--default-color);
  background-color: var(--surface-color);
  border-color: color-mix(in srgb, var(--default-color), transparent 60%);
}

.contact .email-form input[type=text]:focus,
.contact .email-form input[type=email]:focus,
.contact .email-form textarea:focus {
  border-color: var(--accent-color);
  border-width: 2px;
}

.contact .email-form input[type=text]::placeholder,
.contact .email-form input[type=email]::placeholder,
.contact .email-form textarea::placeholder {
  color: color-mix(in srgb, var(--default-color), transparent 70%);
}

.contact .email-form button[type=submit] {
  color: #222222;
  background: #B0C5F1;
  border: 0;
  padding: 10px 30px;
  transition: 0.4s;
  border-radius: 50px;
}

.contact .email-form button[type=submit]:hover {
  background: #6287E2
}

.contact .load {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px; /* Space between dots */
}

.contact .load div {
  width: 8px; /* Small dot size */
  height: 8px;
  background-color: #0E47E0; /* Blue dots */
  border-radius: 50%;
  animation: bounce 1.2s infinite ease-in-out;
}

.contact .load div:nth-child(1) {
  animation-delay: 0s;
}

.contact .load div:nth-child(2) {
  animation-delay: 0.2s;
}

.contact .load div:nth-child(3) {
  animation-delay: 0.4s;
}

.contact .load div:nth-child(4) {
  animation-delay: 0.6s;
}

@keyframes bounce {
  0%, 80%, 100% {
      transform: scale(0.8);
      opacity: 0.3;
  }
  40% {
      transform: scale(1);
      opacity: 1;
  }
}



/*--------------------------------------------------------------
# Service Details Section
--------------------------------------------------------------*/
.service-details .services-list {
  background-color: var(--surface-color);
  padding: 10px 30px;
  border: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);
  margin-bottom: 20px;
  z-index: 2;
}

.service-details .services-list a {
  display: block;
  line-height: 1;
  padding: 8px 0 8px 15px;
  border-left: 3px solid color-mix(in srgb, var(--default-color), transparent 70%);
  margin: 20px 0;
  color: color-mix(in srgb, var(--default-color), transparent 20%);
  transition: 0.3s;
}

.service-details .services-list a.active {
  color: var(--heading-color);
  font-weight: 700;
  border-color: var(--accent-color);
}

.service-details .services-list a:hover {
  border-color: var(--accent-color);
}

.service-details .services-img {
  margin-bottom: 20px;
}

.service-details h3 {
  font-size: 26px;
  font-weight: 700;
}

.service-details h4 {
  font-size: 20px;
  font-weight: 700;
}

.service-details p {
  font-size: 15px;
}

.service-details ul {
  list-style: none;
  padding: 0;
  font-size: 15px;
}

.service-details ul li {
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.service-details ul i {
  font-size: 20px;
  margin-right: 8px;
  color: var(--accent-color);
}

/* Popup Overlay */
.popup-overlay {
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: rgba(0, 0, 0, 0.5); /* Added semi-transparent background */
display: flex;
justify-content: center;
align-items: center;
z-index: 1000;
animation: fadeIn 0.3s ease-in-out;
}

/* Popup Content */
.popup-content {
background: #fff;
border-radius: 10px;
padding: 20px;
max-width: 500px;
width: 90%;
text-align: center;
box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
animation: scaleUp 0.3s ease-in-out;
}

.popup-content p {
font-size: 16px;
color: #838383;
margin-bottom: 20px;
}

.popup-content button {
background-color: #4CAF50;
color: white;
border: none;
padding: 10px 20px;
font-size: 16px;
border-radius: 5px;
cursor: pointer;
transition: background-color 0.3s ease;
}

.popup-content button:hover {
background-color: #45a049;
}

/* Popup Animations */
@keyframes fadeIn {
from {
  opacity: 0;
}
to {
  opacity: 1;
}
}

@keyframes scaleUp {
from {
  transform: scale(0.8);
}
to {
  transform: scale(1);
}
}

/* Mobile Responsive */
@media (max-width: 768px) {
.contact-container {
  flex-direction: column;
  padding: 20px;
}

.contact-info, .contact-form {
  width: 100%;
}

.contact-info h2, .contact-form h2 {
  font-size: 20px;
}

.contact-info p, .contact-form p {
  font-size: 14px;
}

.submit-button {
  padding: 12px 18px;
  font-size: 14px;
}

.social-icons a {
  width: 35px;
  height: 35px;
  font-size: 18px;
}

.popup-content {
  width: 90%;
  padding: 15px;
}
}

/* Small Mobile Devices */
@media (max-width: 480px) {
body {
  font-size: 14px;
}

.contact-info h2, .contact-form h2 {
  font-size: 18px;
}

.submit-button {
  font-size: 14px;
  padding: 8px 16px;
}

.social-icons a {
  width: 30px;
  height: 30px;
  font-size: 16px;
}
}
/*--------------------------------------------------------------
# About Section
--------------------------------------------------------------*/
.about-us-container {

  padding: 50px 20px;
  color: #000000;
}
.about-us-container li{

  color: #000000;
}

.about-us-image img {
  width: 100%;
  height: auto;
  border-radius: 10px;
}
.core-values-list {
  list-style: none;
  padding: 0;
}
.core-values-list li {
  margin-bottom: 10px;
  
}
.about-us-container h3 .accent {
  color: #0E47E0;
}

.about-us-container p {
  align-content: end !important;
  justify-content: left !important;
  text-align: left !important;
}

/*--------------------------------------------------------------
# Service Details Section
--------------------------------------------------------------*/
.service-details .services-list {
  background-color: var(--surface-color);
  padding: 10px 30px;
  border: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);
  margin-bottom: 20px;
  
}

.service-details .services-list a {
  display: block;
  line-height: 1;
  padding: 8px 0 8px 15px;
  border-left: 3px solid color-mix(in srgb, var(--default-color), transparent 70%);
  margin: 20px 0;
  color: color-mix(in srgb, var(--default-color), transparent 20%);
  transition: 0.3s;
}

.service-details .services-list a.active {
  color: var(--heading-color);
  font-weight: 700;
  border-color: var(--accent-color);
}

.service-details .services-list a:hover {
  border-color: var(--accent-color);
}

.service-details .services-img {
  margin-bottom: 20px;
}

.service-details h3 {
  font-size: 26px;
  font-weight: 700;
}

.service-details h4 {
  font-size: 20px;
  font-weight: 700;
}

.service-details p {
  font-size: 15px;
}

.service-details ul {
  list-style: none;
  padding: 0;
  font-size: 15px;
}

.service-details ul li {
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.service-details ul i {
  font-size: 20px;
  margin-right: 8px;
  color: var(--accent-color);
}

/* Example custom styles for images and cards */
.solution-image {
  max-height: 200px;
  object-fit: cover;
  width: 100%;
}

.solution-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  background-color: #f8f9fa;

}

.solution-card h2 {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.solution-card p {
  font-size: 1rem;
  color: #555;
}





html, body {
  height: 100%;
  margin: 0;
}

.main-content {
  min-height: calc(100vh - 72px - 410px); /* 100vh for full viewport height */
  display: flex;
  flex-direction: column;
  padding-top: 72px; /* Adjust padding for the footer height */

}
.main-content h1{
  color: #0E47E0;
  
}

.main-content .button{
  color: #222222;
  background: #B0C5F1;
  border: 0;
  padding: 10px 30px;
  transition: 0.4s;
  border-radius: 50px;
}

.main-content .button:hover {
  background: #6287E2
}

.solution-card {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.solution-card img {
  width: 100%;
  max-height: 200px; /* Adjust as needed */
  object-fit: contain;
}

section {
  flex-grow: 1; /* This ensures the sections grow to fill the remaining space */
}

.it-consulting-container {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center/cover;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.it-consulting-container::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4); /* Adjust opacity as needed */
  z-index: 1;
}

.it-consulting-container > * {
  position: relative;
  z-index: 2;
}


.box-container{
  background-color: rgba(0, 0, 0, 0); /* Black background with 50% transparency */
  border:2px solid white;
  backdrop-filter:blur(50px)
  
}
.box-container p{
  color: rgb(255, 255, 255);

  font-weight: 500;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
}

.Data-Storage-container {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center/cover;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.connectivity-solutions-container {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center center / cover;
  padding: 4rem 2rem;
  width: 100%;
  color: #fff; /* Optional: ensures text stands out */
}


.connectivity-solutions-container::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4); /* Adjust opacity as needed */
  z-index: 1;
}

.connectivity-solutions-container > * {
  position: relative;
  z-index: 2;
}

.communication-solutions-container {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center center / cover;
  padding: 4rem 2rem;
  width: 100%;
  color: #fff; /* Optional: ensures text stands out */
}


.communication-solutions-container::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4); /* Adjust opacity as needed */
  z-index: 1;
}

.communication-solutions-container > * {
  position: relative;
  z-index: 2;
}

.security-solutions-container {
  position: relative;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) no-repeat center center / cover;
  padding: 4rem 2rem;
  width: 100%;
  color: #fff; /* Optional: ensures text stands out */
}


.security-solutions-container::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4); /* Adjust opacity as needed */
  z-index: 1;
}

.security-solutions-container > * {
  position: relative;
  z-index: 2;
}

.background-image::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

}

.container {
  position: relative;

}


/* Terms and Conditions Styles - Blue Theme with White Background */
.TermsAndConditions .container {
  max-width: 1000px;
}

.TermsAndConditions .card {
  border-radius: 10px;
  border: none;
  background-color: #ffffff;
  color: #1e3a5f;
  padding: 20px;
}

.TermsAndConditions h2 {
  color: #1e3a5f;
  font-weight: bold;
  text-align: center;
}

.TermsAndConditions h5 {
  color: #0056b3;
  font-weight: 600;
  margin-bottom: 10px;
}

.TermsAndConditions p, li {
  color: #003366;
  font-size: 16px;
  line-height: 1.6;
}

.TermsAndConditions ul {
  padding-left: 20px;
}

.TermsAndConditions li {
  margin-bottom: 8px;
}

.TermsAndConditions .card:hover {
  background-color: #f0f8ff;
  transition: background-color 0.3s ease-in-out;
}

.modal-content {
  position: relative;
  background-color: #E9F0F8;
  max-width: 100vw;
  max-height: 120vh; /* Ensures it doesn't exceed screen height */
  width: 100%;
  height: auto;
  padding: 20px;
  border: 2px solid #000;
  border-radius: 5px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  overflow: auto; /* Enables scrolling if needed */
  display: flex;
  flex-direction: column;
  background-color: #E9F0F8;

  margin-top: 4vh; /* Pushes the modal down */
  z-index: 1001;

}
.modal-content img{
  max-width:400px ;
    width: 100%;
    height: auto;

    object-fit: contain;
    display: block;
    margin: auto; /* Centers the image */
    padding: 10px 10px 10px 10px;
    border-radius: 10px; /* Optional for a modern look */
}

.modal-content ul,
.modal-content h6
 {
    text-align: left;
}
.modal-content p{
  justify-items: center;
  align-items: center;
  text-align: center;
  color: #6287E2;
  font-weight: 500;
}
.modal-content h2{
  justify-items: center;
  align-items: center;
  text-align: center;
  color: #0E47E0;
  font-weight: 500;
} 

.PrivacyPolicy .container {
  max-width: 1000px;
}

.PrivacyPolicy .card {
  border-radius: 10px;
  border: none;
  background-color: #ffffff;
  color: #1e3a5f;
  padding: 20px;
}

.PrivacyPolicy h2 {
  color: #1e3a5f;
  font-weight: bold;
  text-align: center;
}

.PrivacyPolicy h5 {
  color: #0056b3;
  font-weight: 600;
  margin-bottom: 10px;
}

.PrivacyPolicy p, .PrivacyPolicy li {
  color: #003366;
  font-size: 16px;
  line-height: 1.6;
}

.PrivacyPolicy ul {
  padding-left: 20px;
}

.PrivacyPolicy li {
  margin-bottom: 8px;
}

.PrivacyPolicy .card:hover {
  background-color: #f0f8ff;
  transition: background-color 0.3s ease-in-out;
}
/* service card hover*/
.hover-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border-radius: 12px;
  background: #ffffff;
  padding: 1rem;
}

.hover-card:hover {
  transform: translateY(-10px);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
}




`, "",{"version":3,"sources":["webpack://./src/assets/Main.css"],"names":[],"mappings":";AACA,UAAU;AACV;EACE,0NAA0N;EAC1N,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA,yJAAyJ;AACzJ;EACE,2BAA2B,EAAE,2EAA2E;EACxG,wBAAwB,EAAE,sFAAsF;EAChH,wBAAwB,EAAE,qEAAqE;EAC/F,uBAAuB,EAAE,oIAAoI;EAC7J,wBAAwB,EAAE,2LAA2L;EACrN,yBAAyB,EAAE,6GAA6G;AAC1I;;AAEA,oLAAoL;AACpL;;EAEE,oBAAoB,GAAG,gDAAgD;EACvE,0BAA0B,EAAE,uEAAuE;EACnG,sCAAsC,EAAE,4DAA4D;EACpG,wCAAwC,EAAE,4GAA4G;EACtJ,6BAA6B,EAAE,4EAA4E;EAC3G,mCAAmC,EAAE,iHAAiH;AACxJ;;AAEA,0IAA0I;;AAE1I;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;;;AAG3B;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;AACzB;;AAEA;;+DAE+D;AAC/D;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,+DAA+D;EAC/D,qBAAqB;AACvB;;AAEA;;;;;;EAME,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;;+DAE+D;AAC/D;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;EACZ,yCAAyC;EACzC,YAAY;AACd;;;AAGA;EACE,gBAAgB;;AAElB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;;;AAGb;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;+DAE+D;AAC/D,uBAAuB;AACvB;EACE;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,wCAAwC;IACxC,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;EAClC;;EAEA;;;IAGE,mBAAmB;IACnB,WAAW;EACb;;EAEA;;;IAGE,6BAA6B;EAC/B;;EAEA,oBAAoB;EACpB;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;AAEF;;;;AAIA,sBAAsB;AACtB;EACE;IACE,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;EAC3C;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,gFAAgF;IAChF,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,yCAAyC;IACzC,4BAA4B;IAC5B,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,UAAU;IACV,wBAAwB;EAC1B;;EAEA;;IAEE,gCAAgC;IAChC,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,oBAAoB;EACpB;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,4CAA4C;EAC5C;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;;AAGA,sBAAsB;AACtB;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;;AAGA;;+DAE+D;;AAE/D;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2EAA2E;EAC3E,gEAAgE;EAChE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gEAAgE;EAChE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,QAAQ;AACR;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,oBAAoB;EACpB,+EAA+E;EAC/E,eAAe;EACf,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;;;AAIA;;+DAE+D;AAC/D;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,0EAA0E;EAC1E,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;;+DAE+D;AAC/D;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;;+DAE+D;AAC/D;EACE,uCAAuC;EACvC,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;EAC3B,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,+EAA+E;AACjF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2EAA2E;EAC3E,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gEAAgE;AAClE;;AAEA;;+DAE+D;AAC/D;;EAEE,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,wBAAwB;EACxB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;AACF;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA;;+DAE+D;AAC/D;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gEAAgE;EAChE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,2EAA2E;EAC3E;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;;EAEE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,wBAAwB;IACxB,yBAAyB;IACzB,+EAA+E;EACjF;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;EACzC,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,cAAc;EACd,kBAAkB;;EAElB,oCAAoC;AACtC;AACA;EACE;IACE,cAAc;IACd,uBAAuB;EACzB;AACF;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;;;AAIA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;;;AAIA,6BAA6B;AAC7B;EACE,UAAU;EACV,2BAA2B;EAC3B,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB,EAAE,0BAA0B;EAC9C,gBAAgB,EAAE,0BAA0B;AAC9C;;AAEA,yBAAyB;AACzB;EACE,YAAY,EAAE,oCAAoC;EAClD,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,cAAc,EAAE,oBAAoB;EACpC,eAAe;AACjB;;AAEA,6BAA6B;AAC7B,iCAAiC,mBAAmB,EAAE;AACtD,iCAAiC,mBAAmB,EAAE;AACtD,iCAAiC,mBAAmB,EAAE;AACtD,iCAAiC,mBAAmB,EAAE;AACtD,iCAAiC,mBAAmB,EAAE;AACtD,iCAAiC,mBAAmB,EAAE;AACtD,iCAAiC,mBAAmB,EAAE;AACtD,iCAAiC,mBAAmB,EAAE;;AAEtD,kCAAkC;AAClC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;;AAGA;;+DAE+D;AAC/D;EACE,eAAe;;AAEjB;;AAEA;EACE,YAAY;EACZ,aAAa,GAAG,oBAAoB;EACpC,qBAAqB;EACrB,mBAAmB;;;AAGrB;;AAEA;EACE,aAAa,GAAG,oBAAoB;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;;AAElB;;AAEA;EACE,qBAAqB;AACvB;;;;AAIA;;+DAE+D;AAC/D;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;;+DAE+D;AAC/D;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,4EAA4E;AAC9E;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,4EAA4E;EAC5E,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;EAGE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,sCAAsC;EACtC,uEAAuE;AACzE;;AAEA;;;EAGE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;;;EAGE,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ,EAAE,uBAAuB;AACnC;;AAEA;EACE,UAAU,EAAE,mBAAmB;EAC/B,WAAW;EACX,yBAAyB,EAAE,cAAc;EACzC,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;MACI,qBAAqB;MACrB,YAAY;EAChB;EACA;MACI,mBAAmB;MACnB,UAAU;EACd;AACF;;;;AAIA;;+DAE+D;AAC/D;EACE,sCAAsC;EACtC,kBAAkB;EAClB,2EAA2E;EAC3E,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,gFAAgF;EAChF,cAAc;EACd,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;AACA,eAAe;AACf,MAAM;AACN,OAAO;AACP,WAAW;AACX,YAAY;AACZ,8BAA8B,EAAE,sCAAsC;AACtE,aAAa;AACb,uBAAuB;AACvB,mBAAmB;AACnB,aAAa;AACb,kCAAkC;AAClC;;AAEA,kBAAkB;AAClB;AACA,gBAAgB;AAChB,mBAAmB;AACnB,aAAa;AACb,gBAAgB;AAChB,UAAU;AACV,kBAAkB;AAClB,yCAAyC;AACzC,mCAAmC;AACnC;;AAEA;AACA,eAAe;AACf,cAAc;AACd,mBAAmB;AACnB;;AAEA;AACA,yBAAyB;AACzB,YAAY;AACZ,YAAY;AACZ,kBAAkB;AAClB,eAAe;AACf,kBAAkB;AAClB,eAAe;AACf,sCAAsC;AACtC;;AAEA;AACA,yBAAyB;AACzB;;AAEA,qBAAqB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;AAEA;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;;AAEA,sBAAsB;AACtB;AACA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;AACA;;AAEA,yBAAyB;AACzB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;AACA;;+DAE+D;AAC/D;;EAEE,kBAAkB;EAClB,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,mBAAmB;;AAErB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;;+DAE+D;AAC/D;EACE,sCAAsC;EACtC,kBAAkB;EAClB,2EAA2E;EAC3E,mBAAmB;;AAErB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,gFAAgF;EAChF,cAAc;EACd,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;;AAE3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;;;;;AAMA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,sCAAsC,EAAE,mCAAmC;EAC3E,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,yCAAyC;;AAE9D;AACA;EACE,cAAc;;AAEhB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB,EAAE,qBAAqB;EACxC,mBAAmB;AACrB;;AAEA;EACE,YAAY,EAAE,+DAA+D;AAC/E;;AAEA;EACE,kBAAkB;EAClB,iFAAoE;EACpE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8BAA8B,EAAE,6BAA6B;EAC7D,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;;AAGA;EACE,kCAAkC,EAAE,2CAA2C;EAC/E,sBAAsB;EACtB;;AAEF;AACA;EACE,yBAAyB;;EAEzB,gBAAgB;EAChB,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,iFAAyE;EACzE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mFAAuE;EACvE,kBAAkB;EAClB,WAAW;EACX,WAAW,EAAE,sCAAsC;AACrD;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8BAA8B,EAAE,6BAA6B;EAC7D,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mFAAgF;EAChF,kBAAkB;EAClB,WAAW;EACX,WAAW,EAAE,sCAAsC;AACrD;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8BAA8B,EAAE,6BAA6B;EAC7D,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mFAA2E;EAC3E,kBAAkB;EAClB,WAAW;EACX,WAAW,EAAE,sCAAsC;AACrD;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8BAA8B,EAAE,6BAA6B;EAC7D,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;;AAEd;;AAEA;EACE,kBAAkB;;AAEpB;;;AAGA,mEAAmE;AACnE;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB,EAAE,4CAA4C;EAC/D,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,cAAc,EAAE,gCAAgC;EAChD,aAAa;EACb,sBAAsB;EACtB,yBAAyB;;EAEzB,eAAe,EAAE,0BAA0B;EAC3C,aAAa;;AAEf;AACA;EACE,gBAAgB;IACd,WAAW;IACX,YAAY;;IAEZ,mBAAmB;IACnB,cAAc;IACd,YAAY,EAAE,sBAAsB;IACpC,4BAA4B;IAC5B,mBAAmB,EAAE,+BAA+B;AACxD;;AAEA;;;IAGI,gBAAgB;AACpB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;AACA,sBAAsB;AACtB;EACE,qDAAqD;EACrD,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,4CAA4C;AAC9C","sourcesContent":["\r\n/* Fonts */\r\n:root {\r\n  --default-font: \"Roboto\",  system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\r\n  --heading-font: \"Montserrat\",  sans-serif;\r\n  --nav-font: \"Poppins\",  sans-serif;\r\n}\r\n\r\n/* Global Colors - The following color variables are used throughout the website. Updating them here will change the color scheme of the entire website */\r\n:root { \r\n  --background-color: #ffffff; /* Background color for the entire website, including individual sections */\r\n  --default-color: #222222; /* Default color used for the majority of the text content across the entire website */\r\n  --heading-color: #172a28; /* Color for headings, subheadings and title throughout the website */\r\n  --accent-color: #222222; /* Accent color that represents your brand on the website. It's used for buttons, links, and other elements that need to stand out */\r\n  --surface-color: #ffffff; /* The surface color is used as a background of boxed elements within sections, such as cards, icon boxes, or other elements that require a visual separation from the global background. */\r\n  --contrast-color: #ffffff; /* Contrast color for text, ensuring readability against backgrounds of accent, heading, or default colors. */\r\n}\r\n\r\n/* Nav Menu Colors - The following color variables are used specifically for the navigation menu. They are separate from the global colors to allow for more customization options */\r\n:root {\r\n  \r\n  --nav-color: #222222;  /* The default color of the main navmenu links */\r\n  --nav-hover-color: #0E47E0; /* Applied to main navmenu links when they are hovered over or active */\r\n  --nav-mobile-background-color: #E9F0F8; /* Used as the background color for mobile navigation menu */\r\n  --nav-dropdown-background-color: #B0C5F1; /* Used as the background color for dropdown items that appear when hovering over primary navigation items */\r\n  --nav-dropdown-color: #222222; /* Used for navigation links of the dropdown items in the navigation menu. */\r\n  --nav-dropdown-hover-color: #0E47E0; /* Similar to --nav-hover-color, this color is applied to dropdown navigation links when they are hovered over. */\r\n}\r\n\r\n/* Color Presets - These classes override global colors when applied to any section or element, providing reuse of the sam color scheme. */\r\n\r\n.light-background {\r\n  --background-color: #ffffff;\r\n  --surface-color: #ffffff;\r\n}\r\n\r\n.dark-background {\r\n  --background-color: #ffffff;\r\n  --default-color: #252525;\r\n  --heading-color: #ffffff;\r\n  --surface-color: #252525;\r\n  --contrast-color: #ffffff;\r\n\r\n\r\n}\r\n\r\n.accent-background {\r\n  --background-color: #ffffff;\r\n  --default-color: #252525;\r\n  --heading-color: #252525;\r\n  --accent-color: #ffffff;\r\n  --contrast-color: #000000;\r\n}\r\n\r\n/* Smooth scroll */\r\n:root {\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n/*--------------------------------------------------------------\r\n# General Styling & Shared Classes\r\n--------------------------------------------------------------*/\r\nbody {\r\n  color: var(--default-color);\r\n  background-color: var(--background-color);\r\n  font-family: 'Poppins', sans-serif;\r\n}\r\n\r\na {\r\n  color: var(--accent-color);\r\n  text-decoration: none;\r\n  transition: 0.3s;\r\n}\r\n\r\na:hover {\r\n  color: color-mix(in srgb, var(--accent-color), transparent 25%);\r\n  text-decoration: none;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  color: var(--heading-color);\r\n  font-family: var(--heading-font);\r\n}\r\n\r\n/*--------------------------------------------------------------\r\n# Global Header\r\n--------------------------------------------------------------*/\r\n.header {\r\n  --background-color: #ffffff;\r\n  --heading-color: #252525;\r\n  color: var(--default-color);\r\n  transition: all 0.5s;\r\n  z-index: 997;\r\n  background-color: var(--background-color);\r\n  height: 72px;\r\n}\r\n\r\n\r\n.header .branding {\r\n  min-height: 60px;\r\n\r\n}\r\n\r\n.header .logo {\r\n  line-height: 1;\r\n}\r\n\r\n.header .logo img {\r\n  height: 72px;\r\n  width: auto;\r\n\r\n  \r\n}\r\n\r\n.header .logo h1 {\r\n  font-size: 30px;\r\n  margin: 0;\r\n  font-weight: 700;\r\n  color: var(--heading-color);\r\n}\r\n\r\n.header .logo span {\r\n  font-size: 32px;\r\n  margin-left: 2px;\r\n  color: var(--nav-hover-color);\r\n}\r\n\r\n.scrolled .header {\r\n  box-shadow: 0px 0 18px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/*--------------------------------------------------------------\r\n# Navigation Menu\r\n--------------------------------------------------------------*/\r\n/* Desktop Navigation */\r\n@media (min-width: 1200px) {\r\n  .navmenu {\r\n    padding: 0;\r\n  }\r\n\r\n  .navmenu ul {\r\n    margin: 0;\r\n    padding: 0;\r\n    display: flex;\r\n    list-style: none;\r\n    align-items: center;\r\n  }\r\n\r\n  .navmenu li {\r\n    position: relative;\r\n  }\r\n\r\n  .navmenu > ul > li {\r\n    white-space: nowrap;\r\n    padding: 15px 14px;\r\n    position: relative;\r\n  }\r\n\r\n  .navmenu > ul > li:last-child {\r\n    padding-right: 0;\r\n  }\r\n\r\n  .navmenu a,\r\n  .navmenu a:focus {\r\n    color: var(--nav-color);\r\n    font-size: 15px;\r\n    padding: 0 2px;\r\n    font-family: var(--nav-font);\r\n    font-weight: 500;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    white-space: nowrap;\r\n    transition: 0.3s;\r\n    position: relative;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .navmenu a i,\r\n  .navmenu a:focus i {\r\n    font-size: 12px;\r\n    line-height: 0;\r\n    margin-left: 5px;\r\n    transition: 0.3s;\r\n  }\r\n\r\n  .navmenu > ul > li > a:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    height: 2px;\r\n    bottom: -6px;\r\n    left: 0;\r\n    background-color: var(--nav-hover-color);\r\n    visibility: hidden;\r\n    width: 0;\r\n    transition: all 0.3s ease-in-out;\r\n  }\r\n\r\n  .navmenu a:hover:before,\r\n  .navmenu li:hover > a:before,\r\n  .navmenu .active:before {\r\n    visibility: visible;\r\n    width: 100%;\r\n  }\r\n\r\n  .navmenu li:hover > a,\r\n  .navmenu .active,\r\n  .navmenu .active:focus {\r\n    color: var(--nav-hover-color);\r\n  }\r\n\r\n  /* Dropdown styles */\r\n  .navmenu .dropdown-content {\r\n    display: none;\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 0;\r\n    background: #fff;\r\n    min-width: 200px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\r\n    z-index: 99;\r\n    padding: 10px 0;\r\n  }\r\n\r\n  .navmenu .dropdown-content li {\r\n    width: 100%;\r\n  }\r\n\r\n  .navmenu .dropdown-content li a {\r\n    padding: 10px 20px;\r\n    font-size: 14px;\r\n    color: #333;\r\n    transition: background 0.3s;\r\n  }\r\n\r\n  .navmenu .dropdown-content li a:hover {\r\n    background: #75acfe;\r\n  }\r\n\r\n  .navmenu .dropdown:hover .dropdown-content {\r\n    display: block;\r\n  }\r\n  \r\n}\r\n\r\n\r\n\r\n/* Mobile Navigation */\r\n@media (max-width: 1199px) {\r\n  .mobile-nav-toggle {\r\n    color: var(--nav-color);\r\n    font-size: 30px;\r\n    line-height: 1;\r\n    margin-right: 12px;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease-in-out;\r\n    background-color: #B0C5F1;\r\n    padding: 10px;\r\n    border-radius: 6px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\r\n  }\r\n\r\n  .navmenu {\r\n    padding: 0;\r\n    z-index: 9997;\r\n  }\r\n\r\n  .navmenu > ul {\r\n    display: none;\r\n    list-style: none;\r\n    position: fixed;\r\n    top: 60px;\r\n    left: 20px;\r\n    right: 20px;\r\n    bottom: 20px;\r\n    background: linear-gradient(135deg, var(--nav-mobile-background-color), #D9E3F1);\r\n    border-radius: 8px;\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\r\n    transition: 0.3s ease-in-out;\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n\r\n  .mobile-nav-active .navmenu > ul {\r\n    display: block;\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n\r\n  .navmenu a,\r\n  .navmenu a:focus {\r\n    color: var(--nav-dropdown-color);\r\n    padding: 12px 20px;\r\n    font-family: var(--nav-font);\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    transition: 0.3s;\r\n    border-radius: 5px;\r\n  }\r\n\r\n  /* Mobile Dropdown */\r\n  .navmenu .dropdown-content {\r\n    display: none;\r\n    flex-direction: column;\r\n    padding-left: 20px;\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .navmenu .dropdown.open .dropdown-content {\r\n    display: flex;\r\n  }\r\n\r\n  .navmenu .dropdown-content li a {\r\n    padding: 8px 16px;\r\n    font-size: 16px;\r\n  }\r\n\r\n  /* Disable default link behavior if needed */\r\n  .navmenu .dropdown > a::after {\r\n    margin-left: 8px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n\r\n/* Fade-in animation */\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n\r\n/*--------------------------------------------------------------\r\n# Global Footer\r\n--------------------------------------------------------------*/\r\n\r\n.footer {\r\n  background-color: var(--background-color);\r\n  color: var(--default-color);\r\n  padding: 40px 20px;\r\n  font-size: 14px;\r\n}\r\n\r\n.footer-top {\r\n  gap: 40px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.footer-left {\r\n  flex: 2;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .footer-left {\r\n    flex-direction: row;\r\n  }\r\n}\r\n\r\n/* About */\r\n.footer-about .logo {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 30px;\r\n  font-weight: 700;\r\n  color: var(--heading-color);\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.footer-about p {\r\n  margin-top: 8px;\r\n}\r\n\r\n.social-links a {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  border: 1px solid color-mix(in srgb, var(--default-color), transparent 50%);\r\n  color: color-mix(in srgb, var(--default-color), transparent 50%);\r\n  margin-right: 10px;\r\n  transition: 0.3s;\r\n}\r\n\r\n.social-links a:hover {\r\n  color: #0E47E0;\r\n  border-color: #0E47E0;\r\n  transform: scale(1.1);\r\n}\r\n\r\n/* Links */\r\n.footer-links h4 {\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.footer-links ul {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.footer-links ul li {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.footer-links ul a {\r\n  color: color-mix(in srgb, var(--default-color), transparent 30%);\r\n  text-decoration: none;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.footer-links ul a:hover {\r\n  color: #0E47E0;\r\n  transform: scale(1.05);\r\n}\r\n\r\n/* Contact Text */\r\n.footer-contact-text h4 {\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.footer-contact-text p {\r\n  margin: 4px 0;\r\n}\r\n\r\n/* Map */\r\n.footer-map {\r\n  flex: 1;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.map-image {\r\n  width: 100%;\r\n  max-width: 600px;\r\n  border: 2px solid #0E47E0;\r\n  border-radius: 1px;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Copyright */\r\n.footer .copyright {\r\n  padding-top: 30px;\r\n  padding-bottom: 30px;\r\n  border-top: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);\r\n  font-size: 13px;\r\n  color: var(--default-color);\r\n}\r\n\r\n.footer .sitename-footer,\r\n.footer .sitename {\r\n  color: #0E47E0;\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n\r\n/*--------------------------------------------------------------\r\n# Scroll Top Button\r\n--------------------------------------------------------------*/\r\n.scroll-top {\r\n  position: fixed;\r\n  visibility: hidden;\r\n  opacity: 0;\r\n  right: 15px;\r\n  bottom: -15px;\r\n  z-index: 99999;\r\n  background-color: #0E47E0;\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 50px;\r\n  transition: all 0.4s;\r\n}\r\n\r\n.scroll-top i {\r\n  font-size: 24px;\r\n  color: var(--contrast-color);\r\n  line-height: 0;\r\n}\r\n\r\n.scroll-top:hover {\r\n  background-color: color-mix(in srgb, var(--accent-color), transparent 20%);\r\n  color: var(--contrast-color);\r\n}\r\n\r\n.scroll-top.active {\r\n  visibility: visible;\r\n  opacity: 1;\r\n  bottom: 15px;\r\n}\r\n\r\n/*--------------------------------------------------------------\r\n# Disable aos animation delay on mobile devices\r\n--------------------------------------------------------------*/\r\n@media screen and (max-width: 768px) {\r\n  [data-aos-delay] {\r\n    transition-delay: 0 !important;\r\n  }\r\n}\r\n\r\n/*--------------------------------------------------------------\r\n# Global Page Titles & Breadcrumbs\r\n--------------------------------------------------------------*/\r\n.page-title {\r\n  --background-color: var(--accent-color);\r\n  --default-color: #fff;\r\n  --heading-color: #fff;\r\n  color: var(--default-color);\r\n  background-color: var(--background-color);\r\n  position: relative;\r\n}\r\n\r\n.page-title .heading {\r\n  padding: 160px 0 80px 0;\r\n  border-top: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);\r\n}\r\n\r\n.page-title .heading h1 {\r\n  font-size: 38px;\r\n  font-weight: 700;\r\n}\r\n\r\n.page-title nav {\r\n  background-color: color-mix(in srgb, var(--default-color), transparent 92%);\r\n  padding: 20px 0;\r\n}\r\n\r\n.page-title nav ol {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  list-style: none;\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n\r\n.page-title nav ol a {\r\n  color: color-mix(in srgb, var(--default-color), transparent 50%);\r\n}\r\n\r\n.page-title nav ol a:hover {\r\n  color: var(--default-color);\r\n}\r\n\r\n.page-title nav ol li+li {\r\n  padding-left: 10px;\r\n}\r\n\r\n.page-title nav ol li+li::before {\r\n  content: \"/\";\r\n  display: inline-block;\r\n  padding-right: 10px;\r\n  color: color-mix(in srgb, var(--default-color), transparent 50%);\r\n}\r\n\r\n/*--------------------------------------------------------------\r\n# Global Sections\r\n--------------------------------------------------------------*/\r\nsection,\r\n.section {\r\n  color: rgb(0, 0, 0);\r\n  background-color: var(--background-color);\r\n  padding: 60px 0;\r\n  scroll-margin-top: 112px;\r\n  overflow: clip;\r\n  font-weight: 400;\r\n}\r\n\r\n@media (max-width: 1199px) {\r\n\r\n  section,\r\n  .section {\r\n    scroll-margin-top: 100px;\r\n  }\r\n}\r\n\r\n/*--------------------------------------------------------------\r\n# Global Section Titles\r\n--------------------------------------------------------------*/\r\n.section-title {\r\n  text-align: center;\r\n  padding-bottom: 60px;\r\n  position: relative;\r\n}\r\n\r\n.section-title h2 {\r\n  font-size: 32px;\r\n  font-weight: 700;\r\n  margin-bottom: 20px;\r\n  padding-bottom: 20px;\r\n  position: relative;\r\n}\r\n\r\n.section-title h2:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  display: block;\r\n  width: 50px;\r\n  height: 3px;\r\n  background: var(--accent-color);\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  margin: auto;\r\n}\r\n\r\n.section-title p {\r\n  margin-bottom: 0;\r\n}\r\n\r\n\r\n\r\n/*--------------------------------------------------------------\r\n# Hero Section\r\n--------------------------------------------------------------*/\r\n.hero {\r\n  width: 100%;\r\n  position: relative;\r\n  padding: 140px 0 0 0;\r\n}\r\n\r\n.hero .container {\r\n  position: relative;\r\n  z-index: 3;\r\n}\r\n\r\n.hero h2 {\r\n  font-size: 48px;\r\n  font-weight: 700;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.hero h2 .accent {\r\n  color: #0E47E0;\r\n}\r\n\r\n.hero p {\r\n  color: color-mix(in srgb, var(--default-color), transparent 20%);\r\n  font-weight: 500;\r\n  font-size: medium;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.hero .btn-get-started {\r\n  color: var(--contrast-color);\r\n  background: var(--accent-color);\r\n  font-family: var(--heading-font);\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  letter-spacing: 1px;\r\n  display: inline-block;\r\n  padding: 14px 40px;\r\n  border-radius: 50px;\r\n  transition: 0.3s;\r\n  border: 2px solid color-mix(in srgb, var(--default-color), transparent 10%);\r\n  background-color: #E9F0F8\r\n}\r\n\r\n.hero .btn-get-started:hover {\r\n  border-color: #0E47E0 ;\r\n}\r\n\r\n.hero .btn-watch-video {\r\n  font-size: 16px;\r\n  transition: 0.5s;\r\n  margin-left: 25px;\r\n  font-weight: 600;\r\n  color: var(--default-color);\r\n}\r\n\r\n.hero .btn-watch-video i {\r\n  color: color-mix(in srgb, var(--default-color), transparent 20%);\r\n  font-size: 32px;\r\n  transition: 0.3s;\r\n  line-height: 0;\r\n  margin-right: 8px;\r\n}\r\n\r\n.hero .btn-watch-video:hover i {\r\n  color: #0485f6;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .hero h2 {\r\n    font-size: 36px;\r\n  }\r\n\r\n  .hero .btn-get-started,\r\n  .hero .btn-watch-video {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n.hero .icon-boxes {\r\n  \r\n  padding-bottom: 60px;\r\n  z-index: 4;\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .hero .icon-boxes:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: calc(50% + 20px);\r\n    background-color: #ffffff;\r\n    border-top: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);\r\n  }\r\n}\r\n\r\n.hero .icon-box {\r\n  padding: 60px 30px;\r\n  position: relative;\r\n  overflow: hidden;\r\n  background-color: #22484b;\r\n  box-shadow: 0 0 29px 0 rgba(0, 0, 0, 0.1);\r\n  transition: all 0.3s ease-in-out;\r\n  border-radius: 8px;\r\n  z-index: 1;\r\n  height: 100%;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.hero .icon-box img {\r\n  width: 100%;\r\n  height: auto;\r\n}\r\n\r\n.hero .icon-box .title {\r\n  font-weight: 700;\r\n  margin-bottom: 15px;\r\n  font-size: 24px;\r\n  color: rgb(255, 255, 255);\r\n}\r\n\r\n.hero .icon-box .title a {\r\n  color: rgb(255, 255, 255);\r\n  transition: 0.3s;\r\n}\r\n\r\n.hero .icon-box .icon {\r\n  margin-bottom: 20px;\r\n  padding-top: 10px;\r\n  display: inline-block;\r\n  transition: all 0.3s ease-in-out;\r\n  font-size: 48px;\r\n  line-height: 1;\r\n  color: rgb(255, 255, 255);\r\n}\r\n\r\n.hero .icon-box:hover {\r\n  background-color: rgb(57, 60, 60);\r\n}\r\n\r\n.hero .icon-box:hover .title a,\r\n.hero .icon-box:hover .icon {\r\n  color: var(--contrast-color);\r\n}\r\n\r\n.gif-title {\r\n  max-width: 90%;\r\n  height: auto;\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  \r\n  animation: fadeInDown 1s ease-in-out;\r\n}\r\n@media (max-width: 576px) {\r\n  .gif-title {\r\n    max-width: 90%;\r\n    margin: 0 auto 2px auto;\r\n  }\r\n}\r\n\r\n/* leader section*/\r\n.leaders {\r\n  padding: 4rem 0;\r\n  background: #ffffff;\r\n}\r\n\r\n.section-title h2 {\r\n  font-size: 2.5rem;\r\n  font-weight: bold;\r\n  color: #0056b3;\r\n}\r\n\r\n\r\n\r\n.leader-item {\r\n  background: linear-gradient(135deg, #e0f0ff 0%, #ffffff 100%);\r\n  border: 2px solid #a5b4c4;\r\n  padding: 30px 20px;\r\n  border-radius: 16px;\r\n  box-shadow: 0px 8px 20px rgba(0, 70, 140, 0.1);\r\n  text-align: center;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.leader-item:hover {\r\n  background: linear-gradient(135deg, #d0e8ff 0%, #ffffff 100%);\r\n  transform: translateY(-5px);\r\n  box-shadow: 0px 12px 25px rgba(0, 70, 140, 0.2);\r\n}\r\n\r\n.leader-item img {\r\n  width: auto;\r\n  height: 300px;\r\n  object-fit: cover;\r\n  border-radius: 50%;\r\n  margin-bottom: 20px;\r\n  border: 2px solid #3f71a7;\r\n}\r\n\r\n.leader-item h3 {\r\n  font-size: 1.4rem;\r\n  color: #0056b3;\r\n  margin-bottom: 10px;\r\n  font-weight: bold;\r\n}\r\n\r\n.leader-item p {\r\n  font-size: 1rem;\r\n  color: #000000;\r\n  margin: 0;\r\n}\r\n\r\n\r\n\r\n/* Basic animation settings */\r\n.animated-list li {\r\n  opacity: 0;\r\n  transform: translateY(20px);\r\n  animation: fadeInUp 0.6s ease forwards;\r\n  position: relative;\r\n  padding-left: 30px; /* leave space for arrow */\r\n  list-style: none; /* remove default bullet */\r\n}\r\n\r\n/* Arrow before each li */\r\n.animated-list li::before {\r\n  content: \"➔\"; /* You can change arrow style here */\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  color: #0056b3; /* Dark blue arrow */\r\n  font-size: 18px;\r\n}\r\n\r\n/* Delay animation for each */\r\n.animated-list li:nth-child(1) { animation-delay: 0s; }\r\n.animated-list li:nth-child(2) { animation-delay: 1s; }\r\n.animated-list li:nth-child(3) { animation-delay: 2s; }\r\n.animated-list li:nth-child(4) { animation-delay: 3s; }\r\n.animated-list li:nth-child(5) { animation-delay: 4s; }\r\n.animated-list li:nth-child(6) { animation-delay: 5s; }\r\n.animated-list li:nth-child(7) { animation-delay: 6s; }\r\n.animated-list li:nth-child(8) { animation-delay: 7s; }\r\n\r\n/* Fade in and move up animation */\r\n@keyframes fadeInUp {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n\r\n/*--------------------------------------------------------------\r\n# Clients Section\r\n--------------------------------------------------------------*/\r\n.clients .swiper {\r\n  padding: 10px 0;\r\n\r\n}\r\n\r\n.clients .swiper-wrapper {\r\n  height: auto;\r\n  display: flex;  /* Enables flexbox */\r\n  justify-items: center;\r\n  align-items: center;\r\n  \r\n\r\n}\r\n\r\n.clients .swiper-slide img {\r\n  display: flex;  /* Enables flexbox */\r\n  justify-items: center;\r\n  align-items: center;\r\n  transition: 0.3s;\r\n  \r\n}\r\n\r\n.clients .swiper-slide img:hover {\r\n  transform: scale(1.1);\r\n}\r\n\r\n\r\n\r\n/*--------------------------------------------------------------\r\n# Services Section\r\n--------------------------------------------------------------*/\r\n.service-item {\r\n  background: linear-gradient(135deg, #f0f8ff 0%, #ffffff 100%);\r\n  border: 2px solid #a5b4c4;\r\n  padding: 30px 25px;\r\n  border-radius: 20px;\r\n  text-align: center;\r\n  transition: all 0.3s ease-in-out;\r\n  height: 100%;\r\n  box-shadow: 0px 8px 20px rgba(0, 70, 140, 0.08);\r\n  position: relative;\r\n}\r\n\r\n.service-item:hover {\r\n  background: linear-gradient(135deg, #d6ebff 0%, #ffffff 100%);\r\n  transform: translateY(-8px);\r\n  box-shadow: 0px 12px 30px rgba(0, 70, 140, 0.2);\r\n}\r\n\r\n.service-item .icon {\r\n  font-size: 40px;\r\n  color: #007BFF;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.service-item h3 {\r\n  font-size: 1.5rem;\r\n  color: #0056b3;\r\n  margin-bottom: 15px;\r\n  font-weight: bold;\r\n}\r\n\r\n.service-item p {\r\n  color: #000000;\r\n  font-size: 1rem;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.service-item .readmore {\r\n  color: #007BFF;\r\n  font-weight: 600;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  transition: 0.3s;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.service-item .readmore i {\r\n  margin-left: 8px;\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.service-item .readmore:hover i {\r\n  transform: translateX(5px);\r\n}\r\n\r\n\r\n/*--------------------------------------------------------------\r\n# Contact Section\r\n--------------------------------------------------------------*/\r\n.contact .info-container {\r\n  background-color: #6287E2;\r\n  height: 100%;\r\n  padding: 20px;\r\n}\r\n\r\n.contact .info-item {\r\n  width: 100%;\r\n  margin-bottom: 20px;\r\n  padding: 20px;\r\n  color: #222222;\r\n  background-color: color-mix(in srgb, var(--contrast-color), transparent 60%);\r\n}\r\n\r\n.contact .info-item:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.contact .info-item i {\r\n  font-size: 20px;\r\n  color: 222222;\r\n  background-color: color-mix(in srgb, var(--contrast-color), transparent 60%);\r\n  width: 44px;\r\n  height: 44px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-radius: 50px;\r\n  transition: all 0.3s ease-in-out;\r\n  margin-right: 15px;\r\n}\r\n\r\n.contact .info-item h3 {\r\n  color: #222222;\r\n  font-size: 20px;\r\n  padding: 0;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.contact .info-item p {\r\n  padding: 0;\r\n  margin-bottom: 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.contact .info-item:hover i {\r\n  background: var(--contrast-color);\r\n  color: var(--accent-color);\r\n}\r\n\r\n.contact .email-form {\r\n  background-color: var(--surface-color);\r\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 30px;\r\n  border-style: solid;\r\n  border-width: 1px;\r\n}\r\n\r\n.contact .email-form input[type=text],\r\n.contact .email-form input[type=email],\r\n.contact .email-form textarea {\r\n  font-size: 14px;\r\n  padding: 10px 15px;\r\n  box-shadow: none;\r\n  border-radius: 0;\r\n  color: var(--default-color);\r\n  background-color: var(--surface-color);\r\n  border-color: color-mix(in srgb, var(--default-color), transparent 60%);\r\n}\r\n\r\n.contact .email-form input[type=text]:focus,\r\n.contact .email-form input[type=email]:focus,\r\n.contact .email-form textarea:focus {\r\n  border-color: var(--accent-color);\r\n  border-width: 2px;\r\n}\r\n\r\n.contact .email-form input[type=text]::placeholder,\r\n.contact .email-form input[type=email]::placeholder,\r\n.contact .email-form textarea::placeholder {\r\n  color: color-mix(in srgb, var(--default-color), transparent 70%);\r\n}\r\n\r\n.contact .email-form button[type=submit] {\r\n  color: #222222;\r\n  background: #B0C5F1;\r\n  border: 0;\r\n  padding: 10px 30px;\r\n  transition: 0.4s;\r\n  border-radius: 50px;\r\n}\r\n\r\n.contact .email-form button[type=submit]:hover {\r\n  background: #6287E2\r\n}\r\n\r\n.contact .load {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 5px; /* Space between dots */\r\n}\r\n\r\n.contact .load div {\r\n  width: 8px; /* Small dot size */\r\n  height: 8px;\r\n  background-color: #0E47E0; /* Blue dots */\r\n  border-radius: 50%;\r\n  animation: bounce 1.2s infinite ease-in-out;\r\n}\r\n\r\n.contact .load div:nth-child(1) {\r\n  animation-delay: 0s;\r\n}\r\n\r\n.contact .load div:nth-child(2) {\r\n  animation-delay: 0.2s;\r\n}\r\n\r\n.contact .load div:nth-child(3) {\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n.contact .load div:nth-child(4) {\r\n  animation-delay: 0.6s;\r\n}\r\n\r\n@keyframes bounce {\r\n  0%, 80%, 100% {\r\n      transform: scale(0.8);\r\n      opacity: 0.3;\r\n  }\r\n  40% {\r\n      transform: scale(1);\r\n      opacity: 1;\r\n  }\r\n}\r\n\r\n\r\n\r\n/*--------------------------------------------------------------\r\n# Service Details Section\r\n--------------------------------------------------------------*/\r\n.service-details .services-list {\r\n  background-color: var(--surface-color);\r\n  padding: 10px 30px;\r\n  border: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);\r\n  margin-bottom: 20px;\r\n  z-index: 2;\r\n}\r\n\r\n.service-details .services-list a {\r\n  display: block;\r\n  line-height: 1;\r\n  padding: 8px 0 8px 15px;\r\n  border-left: 3px solid color-mix(in srgb, var(--default-color), transparent 70%);\r\n  margin: 20px 0;\r\n  color: color-mix(in srgb, var(--default-color), transparent 20%);\r\n  transition: 0.3s;\r\n}\r\n\r\n.service-details .services-list a.active {\r\n  color: var(--heading-color);\r\n  font-weight: 700;\r\n  border-color: var(--accent-color);\r\n}\r\n\r\n.service-details .services-list a:hover {\r\n  border-color: var(--accent-color);\r\n}\r\n\r\n.service-details .services-img {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.service-details h3 {\r\n  font-size: 26px;\r\n  font-weight: 700;\r\n}\r\n\r\n.service-details h4 {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n}\r\n\r\n.service-details p {\r\n  font-size: 15px;\r\n}\r\n\r\n.service-details ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  font-size: 15px;\r\n}\r\n\r\n.service-details ul li {\r\n  padding: 5px 0;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.service-details ul i {\r\n  font-size: 20px;\r\n  margin-right: 8px;\r\n  color: var(--accent-color);\r\n}\r\n\r\n/* Popup Overlay */\r\n.popup-overlay {\r\nposition: fixed;\r\ntop: 0;\r\nleft: 0;\r\nwidth: 100%;\r\nheight: 100%;\r\nbackground: rgba(0, 0, 0, 0.5); /* Added semi-transparent background */\r\ndisplay: flex;\r\njustify-content: center;\r\nalign-items: center;\r\nz-index: 1000;\r\nanimation: fadeIn 0.3s ease-in-out;\r\n}\r\n\r\n/* Popup Content */\r\n.popup-content {\r\nbackground: #fff;\r\nborder-radius: 10px;\r\npadding: 20px;\r\nmax-width: 500px;\r\nwidth: 90%;\r\ntext-align: center;\r\nbox-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\r\nanimation: scaleUp 0.3s ease-in-out;\r\n}\r\n\r\n.popup-content p {\r\nfont-size: 16px;\r\ncolor: #838383;\r\nmargin-bottom: 20px;\r\n}\r\n\r\n.popup-content button {\r\nbackground-color: #4CAF50;\r\ncolor: white;\r\nborder: none;\r\npadding: 10px 20px;\r\nfont-size: 16px;\r\nborder-radius: 5px;\r\ncursor: pointer;\r\ntransition: background-color 0.3s ease;\r\n}\r\n\r\n.popup-content button:hover {\r\nbackground-color: #45a049;\r\n}\r\n\r\n/* Popup Animations */\r\n@keyframes fadeIn {\r\nfrom {\r\n  opacity: 0;\r\n}\r\nto {\r\n  opacity: 1;\r\n}\r\n}\r\n\r\n@keyframes scaleUp {\r\nfrom {\r\n  transform: scale(0.8);\r\n}\r\nto {\r\n  transform: scale(1);\r\n}\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 768px) {\r\n.contact-container {\r\n  flex-direction: column;\r\n  padding: 20px;\r\n}\r\n\r\n.contact-info, .contact-form {\r\n  width: 100%;\r\n}\r\n\r\n.contact-info h2, .contact-form h2 {\r\n  font-size: 20px;\r\n}\r\n\r\n.contact-info p, .contact-form p {\r\n  font-size: 14px;\r\n}\r\n\r\n.submit-button {\r\n  padding: 12px 18px;\r\n  font-size: 14px;\r\n}\r\n\r\n.social-icons a {\r\n  width: 35px;\r\n  height: 35px;\r\n  font-size: 18px;\r\n}\r\n\r\n.popup-content {\r\n  width: 90%;\r\n  padding: 15px;\r\n}\r\n}\r\n\r\n/* Small Mobile Devices */\r\n@media (max-width: 480px) {\r\nbody {\r\n  font-size: 14px;\r\n}\r\n\r\n.contact-info h2, .contact-form h2 {\r\n  font-size: 18px;\r\n}\r\n\r\n.submit-button {\r\n  font-size: 14px;\r\n  padding: 8px 16px;\r\n}\r\n\r\n.social-icons a {\r\n  width: 30px;\r\n  height: 30px;\r\n  font-size: 16px;\r\n}\r\n}\r\n/*--------------------------------------------------------------\r\n# About Section\r\n--------------------------------------------------------------*/\r\n.about-us-container {\r\n\r\n  padding: 50px 20px;\r\n  color: #000000;\r\n}\r\n.about-us-container li{\r\n\r\n  color: #000000;\r\n}\r\n\r\n.about-us-image img {\r\n  width: 100%;\r\n  height: auto;\r\n  border-radius: 10px;\r\n}\r\n.core-values-list {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n.core-values-list li {\r\n  margin-bottom: 10px;\r\n  \r\n}\r\n.about-us-container h3 .accent {\r\n  color: #0E47E0;\r\n}\r\n\r\n.about-us-container p {\r\n  align-content: end !important;\r\n  justify-content: left !important;\r\n  text-align: left !important;\r\n}\r\n\r\n/*--------------------------------------------------------------\r\n# Service Details Section\r\n--------------------------------------------------------------*/\r\n.service-details .services-list {\r\n  background-color: var(--surface-color);\r\n  padding: 10px 30px;\r\n  border: 1px solid color-mix(in srgb, var(--default-color), transparent 90%);\r\n  margin-bottom: 20px;\r\n  \r\n}\r\n\r\n.service-details .services-list a {\r\n  display: block;\r\n  line-height: 1;\r\n  padding: 8px 0 8px 15px;\r\n  border-left: 3px solid color-mix(in srgb, var(--default-color), transparent 70%);\r\n  margin: 20px 0;\r\n  color: color-mix(in srgb, var(--default-color), transparent 20%);\r\n  transition: 0.3s;\r\n}\r\n\r\n.service-details .services-list a.active {\r\n  color: var(--heading-color);\r\n  font-weight: 700;\r\n  border-color: var(--accent-color);\r\n}\r\n\r\n.service-details .services-list a:hover {\r\n  border-color: var(--accent-color);\r\n}\r\n\r\n.service-details .services-img {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.service-details h3 {\r\n  font-size: 26px;\r\n  font-weight: 700;\r\n}\r\n\r\n.service-details h4 {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n}\r\n\r\n.service-details p {\r\n  font-size: 15px;\r\n}\r\n\r\n.service-details ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  font-size: 15px;\r\n}\r\n\r\n.service-details ul li {\r\n  padding: 5px 0;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.service-details ul i {\r\n  font-size: 20px;\r\n  margin-right: 8px;\r\n  color: var(--accent-color);\r\n}\r\n\r\n/* Example custom styles for images and cards */\r\n.solution-image {\r\n  max-height: 200px;\r\n  object-fit: cover;\r\n  width: 100%;\r\n}\r\n\r\n.solution-card {\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  background-color: #f8f9fa;\r\n\r\n}\r\n\r\n.solution-card h2 {\r\n  font-size: 1.2rem;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.solution-card p {\r\n  font-size: 1rem;\r\n  color: #555;\r\n}\r\n\r\n\r\n\r\n\r\n\r\nhtml, body {\r\n  height: 100%;\r\n  margin: 0;\r\n}\r\n\r\n.main-content {\r\n  min-height: calc(100vh - 72px - 410px); /* 100vh for full viewport height */\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding-top: 72px; /* Adjust padding for the footer height */\r\n\r\n}\r\n.main-content h1{\r\n  color: #0E47E0;\r\n  \r\n}\r\n\r\n.main-content .button{\r\n  color: #222222;\r\n  background: #B0C5F1;\r\n  border: 0;\r\n  padding: 10px 30px;\r\n  transition: 0.4s;\r\n  border-radius: 50px;\r\n}\r\n\r\n.main-content .button:hover {\r\n  background: #6287E2\r\n}\r\n\r\n.solution-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n}\r\n\r\n.solution-card img {\r\n  width: 100%;\r\n  max-height: 200px; /* Adjust as needed */\r\n  object-fit: contain;\r\n}\r\n\r\nsection {\r\n  flex-grow: 1; /* This ensures the sections grow to fill the remaining space */\r\n}\r\n\r\n.it-consulting-container {\r\n  position: relative;\r\n  background: url('./ITConsultancy.jpg') no-repeat center center/cover;\r\n  height: 500px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.it-consulting-container::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.4); /* Adjust opacity as needed */\r\n  z-index: 1;\r\n}\r\n\r\n.it-consulting-container > * {\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n\r\n.box-container{\r\n  background-color: rgba(0, 0, 0, 0); /* Black background with 50% transparency */\r\n  border:2px solid white;\r\n  backdrop-filter:blur(50px)\r\n  \r\n}\r\n.box-container p{\r\n  color: rgb(255, 255, 255);\r\n\r\n  font-weight: 500;\r\n  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;\r\n}\r\n\r\n.Data-Storage-container {\r\n  position: relative;\r\n  background: url('./DataInfrastructure.jpg') no-repeat center center/cover;\r\n  height: 500px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.connectivity-solutions-container {\r\n  position: relative;\r\n  background: url('./Cyber Security.jpg') no-repeat center center / cover;\r\n  padding: 4rem 2rem;\r\n  width: 100%;\r\n  color: #fff; /* Optional: ensures text stands out */\r\n}\r\n\r\n\r\n.connectivity-solutions-container::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.4); /* Adjust opacity as needed */\r\n  z-index: 1;\r\n}\r\n\r\n.connectivity-solutions-container > * {\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.communication-solutions-container {\r\n  position: relative;\r\n  background: url('./Communication-Solutions.jpg') no-repeat center center / cover;\r\n  padding: 4rem 2rem;\r\n  width: 100%;\r\n  color: #fff; /* Optional: ensures text stands out */\r\n}\r\n\r\n\r\n.communication-solutions-container::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.4); /* Adjust opacity as needed */\r\n  z-index: 1;\r\n}\r\n\r\n.communication-solutions-container > * {\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.security-solutions-container {\r\n  position: relative;\r\n  background: url('./Security-Solutions.png') no-repeat center center / cover;\r\n  padding: 4rem 2rem;\r\n  width: 100%;\r\n  color: #fff; /* Optional: ensures text stands out */\r\n}\r\n\r\n\r\n.security-solutions-container::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.4); /* Adjust opacity as needed */\r\n  z-index: 1;\r\n}\r\n\r\n.security-solutions-container > * {\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.background-image::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n}\r\n\r\n.container {\r\n  position: relative;\r\n\r\n}\r\n\r\n\r\n/* Terms and Conditions Styles - Blue Theme with White Background */\r\n.TermsAndConditions .container {\r\n  max-width: 1000px;\r\n}\r\n\r\n.TermsAndConditions .card {\r\n  border-radius: 10px;\r\n  border: none;\r\n  background-color: #ffffff;\r\n  color: #1e3a5f;\r\n  padding: 20px;\r\n}\r\n\r\n.TermsAndConditions h2 {\r\n  color: #1e3a5f;\r\n  font-weight: bold;\r\n  text-align: center;\r\n}\r\n\r\n.TermsAndConditions h5 {\r\n  color: #0056b3;\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.TermsAndConditions p, li {\r\n  color: #003366;\r\n  font-size: 16px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.TermsAndConditions ul {\r\n  padding-left: 20px;\r\n}\r\n\r\n.TermsAndConditions li {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.TermsAndConditions .card:hover {\r\n  background-color: #f0f8ff;\r\n  transition: background-color 0.3s ease-in-out;\r\n}\r\n\r\n.modal-content {\r\n  position: relative;\r\n  background-color: #E9F0F8;\r\n  max-width: 100vw;\r\n  max-height: 120vh; /* Ensures it doesn't exceed screen height */\r\n  width: 100%;\r\n  height: auto;\r\n  padding: 20px;\r\n  border: 2px solid #000;\r\n  border-radius: 5px;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\r\n  overflow: auto; /* Enables scrolling if needed */\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: #E9F0F8;\r\n\r\n  margin-top: 4vh; /* Pushes the modal down */\r\n  z-index: 1001;\r\n\r\n}\r\n.modal-content img{\r\n  max-width:400px ;\r\n    width: 100%;\r\n    height: auto;\r\n\r\n    object-fit: contain;\r\n    display: block;\r\n    margin: auto; /* Centers the image */\r\n    padding: 10px 10px 10px 10px;\r\n    border-radius: 10px; /* Optional for a modern look */\r\n}\r\n\r\n.modal-content ul,\r\n.modal-content h6\r\n {\r\n    text-align: left;\r\n}\r\n.modal-content p{\r\n  justify-items: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  color: #6287E2;\r\n  font-weight: 500;\r\n}\r\n.modal-content h2{\r\n  justify-items: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  color: #0E47E0;\r\n  font-weight: 500;\r\n} \r\n\r\n.PrivacyPolicy .container {\r\n  max-width: 1000px;\r\n}\r\n\r\n.PrivacyPolicy .card {\r\n  border-radius: 10px;\r\n  border: none;\r\n  background-color: #ffffff;\r\n  color: #1e3a5f;\r\n  padding: 20px;\r\n}\r\n\r\n.PrivacyPolicy h2 {\r\n  color: #1e3a5f;\r\n  font-weight: bold;\r\n  text-align: center;\r\n}\r\n\r\n.PrivacyPolicy h5 {\r\n  color: #0056b3;\r\n  font-weight: 600;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.PrivacyPolicy p, .PrivacyPolicy li {\r\n  color: #003366;\r\n  font-size: 16px;\r\n  line-height: 1.6;\r\n}\r\n\r\n.PrivacyPolicy ul {\r\n  padding-left: 20px;\r\n}\r\n\r\n.PrivacyPolicy li {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.PrivacyPolicy .card:hover {\r\n  background-color: #f0f8ff;\r\n  transition: background-color 0.3s ease-in-out;\r\n}\r\n/* service card hover*/\r\n.hover-card {\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  border-radius: 12px;\r\n  background: #ffffff;\r\n  padding: 1rem;\r\n}\r\n\r\n.hover-card:hover {\r\n  transform: translateY(-10px);\r\n  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
